import { createAction } from 'redux-act';
import { ITrackEventAction } from 'modules/ScrShopNew/store/slices/analytics/types';

export const trackEventAction = createAction<ITrackEventAction>();
